export default "/_next/static/chunks/fonts/FontAwesome5_Solid-07c3313b24f7b1ca85ee99b4fa7db55e.ttf";